'use client';
import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import CustomVideo from '@components/CustomVideo';
import cn from './style.module.scss';
interface CommonDynamicVideoProps {
  mobileVideo?: string;
  desktopVideo?: string;
  mobilePoster?: string;
  desktopPoster?: string;
  children?: ReactNode;
  className?: string;
}
export default function CommonDynamicVideo({
  mobileVideo,
  desktopVideo,
  mobilePoster,
  desktopPoster,
  children,
  className,
}: CommonDynamicVideoProps) {
  return (
    <Stack
      component="section"
      className={`${cn.dynamicVideoBanner} ${className}`}
    >
      <Box className={cn.dynamicVideoBlock}>
        <Mobile>
          <CustomVideo src={mobileVideo || ''} poster={mobilePoster} />
        </Mobile>
        <Desktop>
          <CustomVideo src={desktopVideo || ''} poster={desktopPoster} />
        </Desktop>
      </Box>
      {children ? <Box className={cn.dynamicVideoBody}>{children}</Box> : null}
    </Stack>
  );
}
